export default __webpack_public_path__ + "static/media/2.94e75447.png";